import { render, staticRenderFns } from "./IdentityVerificationResult.vue?vue&type=template&id=3e05a730&"
import script from "./IdentityVerificationResult.vue?vue&type=script&lang=js&"
export * from "./IdentityVerificationResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
